import * as ids from 'short-id';
import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import measurement from 'utils/measurement';
import { parseTextShadowString } from 'utils/ui';
import { Layer, TextOverlayState } from '../types';
import { WithKeyTextAssets } from './types';

function parsePaddings(styles) {
  const {
    padding,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
  } = styles;
  if (padding) {
    const value = measurement(padding);
    return {
      paddingTop: value,
      paddingRight: value,
      paddingBottom: value,
      paddingLeft: value,
    };
  }

  return {
    paddingTop: measurement(paddingTop),
    paddingRight: measurement(paddingRight),
    paddingBottom: measurement(paddingBottom),
    paddingLeft: measurement(paddingLeft),
  };
}

export function getTextOverlays(
  config: PodcastTemplateConfig,
  layers: Layer[],
): WithKeyTextAssets<TextOverlayState> {
  const { textOverlayInfo = [] } = config;

  return textOverlayInfo.reduce<WithKeyTextAssets<TextOverlayState>>(
    (acc, overlay) => {
      const id = ids.generate();
      const {
        containerStyle: {
          fontSize,
          height,
          width,
          padding,
          textShadow,
          ...style
        },
      } = overlay;

      const layer = layers[overlay.layerId];

      if (layer?.type !== 'text') {
        throw new Error(
          `Expected text asset to reference "text" layer but got ${layer?.type}`,
        );
      }

      acc.order.push(id);
      acc.data[id] = {
        id,
        advancedTextConfigs: overlay.advancedTextConfigs,
        editor: overlay.editor,
        layerId: layer.id,
        position: {
          left: measurement(overlay.position.properties.left),
          top: measurement(overlay.position.properties.top),
        },
        size: {
          height: measurement(height),
          width: measurement(width),
        },
        style: {
          ...style,
          ...parsePaddings(style),
          fontSize: measurement(fontSize),
          textShadow: parseTextShadowString(textShadow),
        },
        text: overlay.text,
        textBuilderStyles: overlay.textBuilderStyles,
        textHtml: overlay.textHtml,
        textType: overlay.textType,
        version: overlay.version,
      };
      if (overlay.textType) {
        acc.keyAssets[overlay.textType] = id;
      }
      return acc;
    },
    { order: [], data: {}, keyAssets: {} },
  );
}
